'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var React = require('react');
var downshift = require('downshift');
var FontIcon = require('./FontIcon.js');
var react = require('@linaria/react');
var jsxRuntime = require('react/jsx-runtime');
require('prop-types');
require('deepmerge');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);

var itemToString = function itemToString(item) {
  var _item$displayName;
  return (_item$displayName = item === null || item === void 0 ? void 0 : item.displayName) !== null && _item$displayName !== void 0 ? _item$displayName : '';
};

var _exp = function _exp() {
  return function (_ref) {
    var hasError = _ref.hasError;
    return hasError ? 'var(--color-status-critical-lightest)' : 'var(--color-secondary-input-lightest)';
  };
};
var _exp2 = function _exp2() {
  return function (_ref2) {
    var hasError = _ref2.hasError;
    return hasError ? 'var(--color-status-critical-lighter)' : 'var(--color-secondary-input-lighter)';
  };
};
var _exp3 = function _exp3() {
  return function (_ref3) {
    var minWidth = _ref3.minWidth;
    return minWidth || '4.5rem';
  };
};
var _exp4 = function _exp4() {
  return function (_ref4) {
    var maxWidth = _ref4.maxWidth;
    return maxWidth || '100%';
  };
};
var _exp5 = function _exp5() {
  return function (_ref5) {
    var hasLabel = _ref5.hasLabel;
    return hasLabel ? 'var(--space-xy-xSmall-rem)' : 'var(--space-xy-xSmall-rem)';
  };
};
var _exp6 = function _exp6() {
  return function (_ref6) {
    var hasLabel = _ref6.hasLabel;
    return hasLabel ? 'var(--font-lineHeight-m)' : 'var(--font-lineHeight-2xs)';
  };
};
var _exp8 = function _exp8() {
  return function (_ref7) {
    var hasError = _ref7.hasError;
    return hasError ? 'var(--color-status-critical-base)' : 'var(--color-secondary-input-base)';
  };
};
var StyledDropdownContainer = /*#__PURE__*/react.styled('div')({
  name: "StyledDropdownContainer",
  "class": "s11bdbzb",
  propsAsIs: false,
  vars: {
    "s11bdbzb-0": [_exp()],
    "s11bdbzb-1": [_exp2()],
    "s11bdbzb-2": [_exp3()],
    "s11bdbzb-3": [_exp4()],
    "s11bdbzb-4": [_exp5()],
    "s11bdbzb-5": [_exp6()],
    "s11bdbzb-6": [_exp8()]
  }
});
var _exp9 = function _exp9() {
  return function (_ref8) {
    var minWidth = _ref8.minWidth;
    return minWidth || '4.5rem';
  };
};
var _exp10 = function _exp10() {
  return function (_ref9) {
    var maxWidth = _ref9.maxWidth;
    return maxWidth || '100%';
  };
};
var _exp11 = function _exp11() {
  return function (_ref10) {
    var hasError = _ref10.hasError;
    return hasError ? 'var(--color-status-critical-base)' : 'var(--color-secondary-action-base)';
  };
};
var _exp12 = function _exp12() {
  return function (_ref11) {
    var isOpen = _ref11.isOpen;
    return isOpen ? 'block' : 'none';
  };
};
var _exp13 = function _exp13() {
  return function (_ref12) {
    var isOpen = _ref12.isOpen;
    return isOpen ? '0 2px 6px 0 var(--color-secondary-inactive-lighter)' : 'none';
  };
};
var _exp14 = function _exp14() {
  return function (_ref13) {
    var hasError = _ref13.hasError,
      isOpen = _ref13.isOpen;
    if (isOpen) {
      if (hasError) {
        return 'var(--border-width-xSmall) solid var(--color-status-critical-base)';
      }
      return "var(--border-width-xSmall) solid ".concat('var(--color-secondary-action-base)');
    }
    return 'none';
  };
};
var StyledContainer = /*#__PURE__*/react.styled('div')({
  name: "StyledContainer",
  "class": "s1farbs1",
  propsAsIs: false,
  vars: {
    "s1farbs1-0": [_exp9()],
    "s1farbs1-1": [_exp10()],
    "s1farbs1-2": [_exp11()],
    "s1farbs1-3": [_exp12()],
    "s1farbs1-4": [_exp13()],
    "s1farbs1-5": [_exp14()]
  }
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Dropdown = function Dropdown(props) {
  var _selectedItem$display;
  var _useState = React.useState(props.value ? props.options.find(function (option) {
      return option.value === props.value;
    }) : null),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    selectedItem = _useState2[0],
    setSelectedItem = _useState2[1];
  var changeHandler = function changeHandler(e) {
    if (props.onChange) {
      var _e$selectedItem$value, _e$selectedItem, _e$selectedItem2;
      var newEvent = {
        target: {
          value: (_e$selectedItem$value = (_e$selectedItem = e.selectedItem) === null || _e$selectedItem === void 0 ? void 0 : _e$selectedItem.value) !== null && _e$selectedItem$value !== void 0 ? _e$selectedItem$value : ''
        }
      }; // TODO: This is NOT a ChangeEvent it could cause problems if we pretend to use it as one.

      setSelectedItem((_e$selectedItem2 = e.selectedItem) !== null && _e$selectedItem2 !== void 0 ? _e$selectedItem2 : null);
      props.onChange(newEvent);
    }
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter') {
      openMenu();
    }
  };
  var _useSelect = downshift.useSelect({
      id: props.id,
      items: props.options,
      itemToString: itemToString,
      selectedItem: selectedItem,
      onSelectedItemChange: changeHandler
    }),
    isOpen = _useSelect.isOpen,
    getToggleButtonProps = _useSelect.getToggleButtonProps,
    getLabelProps = _useSelect.getLabelProps,
    getMenuProps = _useSelect.getMenuProps,
    highlightedIndex = _useSelect.highlightedIndex,
    getItemProps = _useSelect.getItemProps,
    openMenu = _useSelect.openMenu;
  return /*#__PURE__*/jsxRuntime.jsxs(StyledContainer, {
    isOpen: isOpen,
    className: props.className,
    hasError: props.hasError,
    maxWidth: props.maxWidth,
    minWidth: props.minWidth,
    children: [/*#__PURE__*/jsxRuntime.jsxs(StyledDropdownContainer, _objectSpread(_objectSpread({
      hasError: !!props.hasError,
      hasLabel: !!props.label
    }, getToggleButtonProps()), {}, {
      role: "combobox",
      tabindex: 0,
      onKeyDown: handleKeyDown,
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {
        className: "dropdown ".concat(isOpen ? 'opened ' : '', " ").concat(props.disabled ? 'disabled ' : ''),
        children: (_selectedItem$display = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.displayName) !== null && _selectedItem$display !== void 0 ? _selectedItem$display : ' '
      }), /*#__PURE__*/jsxRuntime.jsxs("label", _objectSpread(_objectSpread({
        id: props.labelId,
        className: selectedItem ? 'filled' : ''
      }, getLabelProps()), {}, {
        children: [props.label, props.required && /*#__PURE__*/jsxRuntime.jsx("span", {
          className: "red",
          children: "*"
        })]
      })), props.placeholder && !props.label && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: selectedItem ? 'filled placeholder-text' : 'placeholder-text',
        children: props.placeholder
      }), /*#__PURE__*/jsxRuntime.jsx("div", {
        className: isOpen && !props.disabled ? 'icon-container flipped' : 'icon-container',
        children: /*#__PURE__*/jsxRuntime.jsx(FontIcon["default"], {
          iconName: props.icon ? props.icon : 'sort-descending',
          fontSize: "var(--font-size-s)",
          padding: "var(--space-xy-xxSmall-rem)"
        })
      }), props.helperText && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: props.hasError || props.required ? 'help' : 'info',
        children: props.helperText
      })]
    })), !props.disabled ? /*#__PURE__*/jsxRuntime.jsx("ul", _objectSpread(_objectSpread({
      className: "menu"
    }, getMenuProps()), {}, {
      children: isOpen ? !props.options.length ? /*#__PURE__*/jsxRuntime.jsx("li", {
        children: "No results found"
      }) : props.options.map(function (item, index) {
        return /*#__PURE__*/jsxRuntime.jsx("li", _objectSpread(_objectSpread({
          role: "option",
          "aria-selected": highlightedIndex === index
        }, getItemProps({
          item: item,
          index: index
        })), {}, {
          style: {
            backgroundColor: highlightedIndex === index ? 'var(--color-secondary-input-lightest)' : 'inherit'
          },
          children: item.displayName
        }), "".concat(item.value).concat(index));
      }) : null
    })) : null]
  });
};

exports["default"] = Dropdown;
